export const Header = () => (
  <header className="ob-header ob-fade" data-testid="fiche-header">
    <p className="ob-brand" data-testid="fiche-brand">OMBODHI</p>
    <h1 className="ob-title">Parlons de vos besoins</h1>
    <p className="ob-subtitle">Deux étapes pour nommer ce qui compte pour votre organisation.</p>
    <div className="ob-rule" />
    <p className="ob-intro">
      Vous avez téléchargé la Check-list. Cette fiche prend environ cinq minutes. Vos réponses me permettent de
      préparer une suite précise, à votre rythme.
    </p>
    <p className="ob-sign">Alexandra Pouget, fondatrice d'Ombodhi</p>
  </header>
);

export const Progress = ({ step }) => (
  <div className="ob-progress" data-testid="fiche-progress">
    <span className="ob-progress-label">{step} / 2</span>
    <div className="ob-progress-track">
      <div className="ob-progress-bar" style={{ transform: `scaleX(${step / 2})` }} />
    </div>
  </div>
);

export const Footer = () => (
  <footer className="ob-footer" data-testid="fiche-footer">
    <div className="ob-rule" />
    <p className="ob-tagline">Là où le leadership se régule, l'organisation se transforme.</p>
    <p className="ob-contact">
      <a href="mailto:info@ombodhi.ca" data-testid="footer-email-link">info@ombodhi.ca</a>
      <span> · </span>
      <a href="https://ombodhi.ca" target="_blank" rel="noopener noreferrer" data-testid="footer-site-link">ombodhi.ca</a>
      <span> · </span>
      <a href="tel:+14385446959" data-testid="footer-phone-link">(438) 544-6959</a>
    </p>
  </footer>
);

export const Thanks = () => (
  <div className="ob-thanks ob-fade" data-testid="fiche-thanks">
    <p className="ob-thanks-title">Merci.</p>
    <p className="ob-thanks-text">
      Votre fiche est bien reçue. Je la lis personnellement et je vous reviens selon le moyen choisi. Si vous
      souhaitez avancer dès maintenant, réservez une Conversation exécutive de 30 minutes.
    </p>
    <a href="https://vip.ombodhi.ca" target="_blank" rel="noopener noreferrer" className="ob-btn" data-testid="fiche-book-button">
      Réserver ma conversation
    </a>
  </div>
);
